var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getAvailableMeasurements from "../../requests/metrics/getAvailableMeasurements";
/**
 *
 */
var GetAvailableMeasurementsCommand = /** @class */ (function (_super) {
    __extends(GetAvailableMeasurementsCommand, _super);
    function GetAvailableMeasurementsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation string
     * @param measurementCollection string
     * @return {*}
     */
    GetAvailableMeasurementsCommand.prototype.execute = function (organisation, assets, measurementCollection) {
        this.measurementCollection = measurementCollection;
        var promise = getAvailableMeasurements(organisation, assets.map(function (asset) { return asset.getMetricsDbId(); }).filter(function (value) { return !!value; }));
        promise.then(this.then);
        return promise;
    };
    GetAvailableMeasurementsCommand.prototype.then = function (response) {
        this.measurementCollection.reset(true);
        this.measurementCollection.addAll(Object.values(response));
    };
    return GetAvailableMeasurementsCommand;
}(Command));
export default GetAvailableMeasurementsCommand;
